import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ContactAgreementReferenceService extends BaseReferenceService {
  constructor() {
    super('ContactAgreementReference');
  }
}
